import React from 'react';
import './Header.css';
import exLogo from '../../resouces/ex-logo.svg';
import appStoreLogo from '../../resouces/app-store-logo.svg';
import googlePlayLogo from '../../resouces/google-play-logo.svg';
import Settings from "../Settings/Settings";
import Camera from "../Camera/Camera";
import scanIcon from "../../resouces/scan-icon.svg";


export default class Header extends React.Component {

    state = {
        isCameraActive: false
    }

    onSwitchCamera(state = false) {
        this.setState({isCameraActive: state})
    }

    render() {
        const {selectedLanguage} = this.props;

        return (
            <React.Fragment>
                <div id='MainHeaderBlock'>
                    <a id='ExLink'
                       target="_blank"
                       rel="noopener noreferrer"
                       href="https://explainitapp.com">
                        <img alt="Logo" src={exLogo}/>
                    </a>

                    {
                       // SCAN BUTTON

                       /* <div id="ScanButton"
                             onClick={() => this.onSwitchCamera(true)}>

                            <p>Scan</p>
                            <img src={scanIcon} alt="Start scan"/>
                        </div>*/
                    }
                    <div id='MainLanguageSelector'
                         onClick={() => {Settings.instance.openModal()}}>

                        <img alt={selectedLanguage ? selectedLanguage : "Language"} src={`./res/flags/${selectedLanguage ? selectedLanguage + '.svg' : 'globe.png'}`}/>
                    </div>

                    <a id='AppStoreLink'
                       target="_blank"
                       rel="noopener noreferrer"
                       href="https://explainitapp.com/download">
                        <img alt="App Store" src={appStoreLogo}/>
                        <img alt="Google play" src={googlePlayLogo}/>
                    </a>

                </div>

                <Camera isActive={this.state.isCameraActive} onClose={() => this.onSwitchCamera(false)} />

            </React.Fragment>
        );
    }
}
